export class Enrollment {
public EnrollmentId:string='newid()';
public EnrollDate= new Date();
public Status:string=null;
public PatientId:number=null;
public Category:string=null;
public Form:string=null;
}


export class MasterData {
public Id:number=null;
public Type:string=null;
public Value:string=null;
}


export class MedicalInfo {
public Id:number=null;
public PriorTherapy:string=null;
public ReasonforDiscontinuation:string=null;
public YearofDiscontinuation:number=null;
public EnrollmentId:string=null;
}


export class MedicineDetail {
public Id:number=null;
public Dosing:string=null;
public DosageMetric:string=null;
public Dosage:string=null;
public Medicine:string=null;
public Quantity:number=null;
public PrescriptionId:number=null;
}


export class PatientInfo {
public Id:number=null;
public Patient:string=null;
public Caregiver:string=null;
public DOB= null ;
public Gender:string=null;
public Weight:number=null;
public Height:number=null;
public Address:string=null;
public Phone:number=null;
public Email:string=null;
public AnyAllergies:string=null;
}


export class Prescription {
public Id:number=null;
public Type:string=null;
public Refill:string=null;
public Auth:string=null;
public EnrollmentId:string=null;
}


export class EnrollmentModel {
public EnrollmentId:string=null;
public EnrollDate= null ;
public Status:string=null;
public PatientInfo=null;
public MedicalInfo=null;
public Prescriptions:PrescriptionModel[]=null;
public State:string=null;
}


export class PrescriptionModel {
public Type:string=null;
public Refill:string=null;
public Authorization:string=null;
public MedicineDetails:MedicineDetail[]=null;
public Id:number=null;
}


export namespace Response {export class EnrollmentResponse {
public Id:string=null;
public ErrorMessage:string=null;
}
}


export namespace SmartyStreets {export class AddressVerificationResponse {
public input_index:number=null;
public candidate_index:number=null;
public delivery_line_1:string=null;
public last_line:string=null;
public delivery_point_barcode:string=null;
public components=null;
public metadata=null;
public analysis=null;
}
export class Analysis {
public dpv_match_code:string=null;
public dpv_footnotes:string=null;
public dpv_vacant:string=null;
}
export class Component {
public primary_number:string=null;
public city_name:string=null;
public zipcode:string=null;
public state_abbreviation:string=null;
public street_postdirection:string=null;
}
export class Metadata {
public record_type:string=null;
public zip_type:string=null;
public building_default_indicator:string=null;
}
}


export class HttpResponseMessage
{
StatusCode: number;
Content: any;
Headers: any;
ErrorMessage: any;
ContentType: string;
StatusText: string;
}
